// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2153":"4d7d15f0","4372":"4d7d15f0"}[chunkId] + ".chunk.css";
};